module.exports = require("front-matter");


//////////////////
// WEBPACK FOOTER
// external "front-matter"
// module id = 29
// module chunks = 0